import React from "react";
import { Box, Paper } from "@mui/material";

const CustomVideoPlayer = ({ url }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <iframe
        width="100%"
        height="400"
        src={url}
        title="video player"
        frameborder="0"
        allowFullScreen
      ></iframe>
    </Box>
  );
};

export default CustomVideoPlayer;
